import React, { useContext } from "react";
import type { ComponentType } from "react";
import { AppLayout } from "~/components/Layout/AppLayout";
import { userContext } from "~/context/ContextProvider";
import * as APITypes from "~/API";
import { TopNavFallback } from "./TopNavFallback";
import { SideNavFallback } from "./SideNavFallback";
import { PageContentFallback } from "./PageContentFallback";
import "./Fallbacks.css";

type AppShellFallbackProps = {
  ContentFallback?: ComponentType;
};

/** Full app shell placeholder (top + side + content slot). */
export const AppShellFallback: React.FC<AppShellFallbackProps> = ({
  ContentFallback = PageContentFallback,
}) => {
  const { status } = useContext(userContext);
  const showSideNav = status === APITypes.TenantStatusType.Active;

  return (
    <AppLayout
      TopNavigation={<TopNavFallback />}
      SideNavigation={showSideNav ? <SideNavFallback /> : null}
      PageContent={<ContentFallback />}
    />
  );
};
